"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyLimitedPartnerships$ = exports.CompaniesCompanyLimitedPartnerships$outboundSchema = exports.CompaniesCompanyLimitedPartnerships$inboundSchema = void 0;
exports.companiesCompanyLimitedPartnershipsToJSON = companiesCompanyLimitedPartnershipsToJSON;
exports.companiesCompanyLimitedPartnershipsFromJSON = companiesCompanyLimitedPartnershipsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.CompaniesCompanyLimitedPartnerships$inboundSchema = z.object({
    num_gen_partners: z.nullable(z.number().int()),
    num_lim_partners: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "num_gen_partners": "numGenPartners",
        "num_lim_partners": "numLimPartners",
    });
});
/** @internal */
exports.CompaniesCompanyLimitedPartnerships$outboundSchema = z.object({
    numGenPartners: z.nullable(z.number().int()),
    numLimPartners: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        numGenPartners: "num_gen_partners",
        numLimPartners: "num_lim_partners",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyLimitedPartnerships$;
(function (CompaniesCompanyLimitedPartnerships$) {
    /** @deprecated use `CompaniesCompanyLimitedPartnerships$inboundSchema` instead. */
    CompaniesCompanyLimitedPartnerships$.inboundSchema = exports.CompaniesCompanyLimitedPartnerships$inboundSchema;
    /** @deprecated use `CompaniesCompanyLimitedPartnerships$outboundSchema` instead. */
    CompaniesCompanyLimitedPartnerships$.outboundSchema = exports.CompaniesCompanyLimitedPartnerships$outboundSchema;
})(CompaniesCompanyLimitedPartnerships$ || (exports.CompaniesCompanyLimitedPartnerships$ = CompaniesCompanyLimitedPartnerships$ = {}));
function companiesCompanyLimitedPartnershipsToJSON(companiesCompanyLimitedPartnerships) {
    return JSON.stringify(exports.CompaniesCompanyLimitedPartnerships$outboundSchema.parse(companiesCompanyLimitedPartnerships));
}
function companiesCompanyLimitedPartnershipsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompaniesCompanyLimitedPartnerships$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompaniesCompanyLimitedPartnerships' from JSON`);
}
//# sourceMappingURL=companiescompanylimitedpartnerships.js.map